export enum EsgSourceRelationship {
  Self = 'Self',
  Parent = 'Parent',
  UltimateParent = 'UltimateParent'
}

export interface SecurityEsgScore {
  securityId: number;
  campaignType: string;
  esgScore: number;
  environmentalScore: number;
  socialScore: number;
  governanceScore: number;
  scoreDate: string;
  methodologyYear: number;
  sourceCompanyName: string;
  sourceRelationship: EsgSourceRelationship;
}
